import { useEffect, useRef } from 'react';
import {
  AnalyticsEventData,
  AnalyticsEventImportance,
  AnalyticsEventName,
} from '@cbhq/client-analytics';

import { useAnalytics } from './useAnalytics';

export function useLogEventOnMount(
  eventName: AnalyticsEventName,
  eventData: AnalyticsEventData,
  eventImportance?: AnalyticsEventImportance,
  enabled = true,
) {
  const ref = useRef(true);
  const { logEvent } = useAnalytics();
  useEffect(() => {
    if (enabled && ref.current) {
      ref.current = false;
      logEvent(eventName, eventData, eventImportance);
    }
  }, [enabled, eventData, eventImportance, eventName, logEvent]);
}
